<template>
    <VJoyButton
        v-bind="$attrs"
        :variant="joyVariant"
        class="mui-c-button"
        :class="{'mui-c-button--secondary': variant === 'secondary'}"
        :data-testid="dataTestid"
    >
        <slot />
    </VJoyButton>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyButton, type TJoyButtonVariants} from '@maltjoy/core-vue';
    import type {MuiButtonVariant} from '../types/ui';

    defineOptions({
        inheritAttrs: false,
    });

    const {dataTestid = 'mui-button', variant = 'main'} = defineProps<{
        dataTestid?: string;
        variant?: MuiButtonVariant;
    }>();

    const joyVariant = computed((): TJoyButtonVariants => (variant === 'main' ? 'main' : 'secondary'));
</script>

<style lang="scss">
    .mui-c-button {
        &--secondary.joy-button.joy-button_secondary {
            color: var(--joy-color-primary-50);
            background-color: transparent;
            border-color: var(--joy-color-primary-50);

            // TODO: Ask what the hover and active states look like
            // &:hover,
            // &:active {
            //     color: var(--joy-color-primary-50);
            //     border-color: var(--joy-color-primary-50);
            // }

            // &:focus {
            //     border-color: var(--joy-color-primary-50);
            // }
        }
    }
</style>
